import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Typography} from '@mui/material';

import {EmpionPaper} from '../../../../../../../components/EmpionPaper/EmpionPaper';
import {LanguageContext} from '../../../../../../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../../../../../../layouts/theme/designSystem';
import {capitalizeFirstLetter} from '../../../../../../../utils/capitalizeFirstLetter';
import {CultureType} from '../../../../../culture/dashboard/types/CultureInformationTypes';

interface Props {
  cultureTypeInfo?: CultureType;
  talentFirstName?: string;
}

export const TeamValues = ({cultureTypeInfo, talentFirstName}: Props) => {
  const currentLanguage = useContext(LanguageContext);
  const {t} = useTranslation('translation', {keyPrefix: 'matchDetailsPage.teamValues'});
  const title = talentFirstName ? t('titleWithName', {name: talentFirstName}) : t('title');
  return (
    <EmpionPaper
      sx={{
        backgroundColor: orangeColors[5],
        padding: 2,
        borderRadius: '15px',
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${orangeColors[3]}`,
        flex: 1,
        alignSelf: 'stretch',
      }}
    >
      <Typography variant='h4'>{title}</Typography>
      <Typography
        variant='body1'
        sx={{
          '& p': {
            margin: '10px 0',
          },
        }}
        dangerouslySetInnerHTML={{
          __html:
            cultureTypeInfo?.teamValue?.[`html${capitalizeFirstLetter(currentLanguage) as 'En' | 'De'}`] || 'no values',
        }}
      />
    </EmpionPaper>
  );
};
